"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * @class
 * @classdesc Class with all possible validations needed.<br/>
 * ATTENTION! This is a SINGLETON CLASS so it should be accessed as common.FieldValidation.[methodName]
 * @constructor
 */
function FieldValidation() {}
/**
 * Verify if the passed value is as an email adress format. The control is done with regex.
 * @param {String} value The mail to be checked
 * @returns {String} If the mail is not valid the 'formato email non valido' is returned othervise '' is returned
 */


FieldValidation.prototype.isEmail = function (value) {
  if (value === '') {
    return "";
  }

  var rex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/gi;

  if (rex.test(value)) {
    return "";
  }

  return "formato email non valido";
};

var exp = new FieldValidation();
var _default = exp;
exports.default = _default;